var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#00C8B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2747 20.5018C13.134 20.6432 12.9421 20.7223 12.7426 20.7223C12.5432 20.7223 12.3513 20.6432 12.2106 20.5018L7.96161 16.2521C7.52061 15.8111 7.52061 15.0961 7.96161 14.6559L8.49367 14.1238C8.93467 13.6828 9.64885 13.6828 10.0898 14.1238L12.7426 16.7766L19.9108 9.60846C20.3518 9.16746 21.0667 9.16746 21.5069 9.60846L22.039 10.1405C22.48 10.5815 22.48 11.2965 22.039 11.7367L13.2747 20.5018Z",
    fill: "#010B3B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.81be2e6fdb2312c2ba4af0db7035a495.svg";
export { ForwardRef as ReactComponent };